<template>
  <div :class="classes" v-loading.fullscreen.lock="loading">
    <pt-form-item label="批量上传订单" :required="true" labelWidth="100px">
      <!-- 上传组件 -->
      <el-upload
        ref="excel"
        class="upload-demo"
        action="aa"
        :auto-upload="false"
        :multiple="false"
        :on-change="changHandler"
        :on-remove="removeHandler"
        :file-list="excel"
        v-model="lotForm.excel" name="excel" v-validate="'required'" data-vv-as="上传文件">
        <el-button size="small" type="primary">点击上传</el-button>
        <br>
      </el-upload>
    </pt-form-item>
    <a :href="$privateResourcesUrlDownload+'templates/生命银行导入模板.xlsx'">
      <el-button type="text">下载文件模版</el-button>
    </a>
    <slot />
  </div>
</template>

<script>
import formMixins from 'mixins/form'
// 组件class前缀
const prefixCls = 'pt-business-order-lot-form'

export default {
  name: 'pt-business-order-lot-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  data () {
    return {
      lotForm: {
        clientOrganizationId: '5b6e40155c0eb40001658280',
        remark: '',
        sender: '',
        courierNumber: [{ value: '' }],
        excel: []
      },
      excel: [],
      uploadForm: new FormData(),
      loading: false
    }
  },
  methods: {
    downLoadFile () {
      // this.$privateResourcesUrlDownload()rawdata/0001/sample_FinalReport_0001.txt
    },
    addItem (index) {
      if (this.lotForm.courierNumber[index].value === '') {
        this.$message.error('请填写！')
        return
      }
      this.lotForm.courierNumber.push({ value: '' })
      this.$nextTick(() => {
        document.querySelector('.courier_' + (index + 1) + '>input').focus()
      })
    },
    deleteItem (index) {
      if (index === 0 && this.lotForm.courierNumber.length === 1) {
        this.$message.error('不能再删除了')
        return
      }
      this.$confirm('确定要删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.lotForm.courierNumber.splice(index, 1)
      })
    },
    changHandler (file, fileList) {
      if (fileList.length > 1) {
        fileList.shift()
      }
      this.excel = fileList
      this.lotForm.excel = fileList
    },
    removeHandler (file, fileList) {
      this.excel = fileList
      this.lotForm.excel = fileList
    },
    getNumber (arr) {
      var newArr = []
      arr.forEach(element => {
        if (element.value) {
          newArr.push(element.value)
        }
      })
      return newArr
    },
    submit () {
      this.loading = true
      this.uploadForm = new FormData()
      this.uploadForm.append('excel', this.excel[0].raw)
      this.$store.dispatch('creatLabOrderFlow', this.uploadForm).then(res => {
        this.excel[0].status = 'ready'
        this.loading = false
        this.$router.push({ name: 'gene-lab-order' })
      }).catch((error) => {
        this.loading = false
        this.lotForm.excel[0].status = 'ready'
        this.excel[0] = this.lotForm.excel[0]
        this.$message.error(error)
      })
    }

  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-business-order-lot-form{
  .el-input,el-date-editor{
    width:280px !important;
  }
  .el-upload-list{
    max-width: 800px;
  }
}
</style>
